import React, { useEffect, useState } from "react";
import FaceScanInstructions from "./comp/FaceScanInstructions";
import CameraHelp from "./comp/CameraHelp";
import Header from "../../Header/Header";
import VideoRecorder from "./comp/VideoRecorder";
import { getApi, postApi, putApi } from "../../AppApis";
import { useLocation, useNavigate } from "react-router-dom";
import ProgressBar from "../../../components/ProgressBar";

// import mime from "mime";
export default function FaceLiveness() {
    const [count, setCount] = useState(1);
    const [recordedVideo, setRecordedVideo] = useState();
    const [isPassport, setIsPassport] = useState(false);
    const navigate = useNavigate();
    const [idImages, setIdImages] = useState([]);
    const location = useLocation();
    const stateData = location.state;
    const [personalVerifications, setPersonalVerifications] = useState(false);

    useEffect(() => {
        setIsPassport(stateData?.idType);
        setIdImages(stateData?.documents);
    }, [stateData]);
    const getUserVerifications = async () => {
        try {
            const response = await getApi("/verifications/user-verifications");
            if (response?.response) {
                setPersonalVerifications(response?.response?.data?.personal_verifications);
            }
        } catch (error) {
            console.error("Error fetching verification data:", error);
        }
    };
    useEffect(() => {
        getUserVerifications();
    }, []);

    function base64ToBlob(base64Data, contentType = "image/jpeg") {
        const byteCharacters = atob(base64Data.split(",")[1]);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            byteArrays.push(new Uint8Array(byteNumbers));
        }

        return new Blob(byteArrays, { type: contentType });
    }

    const onSubmitVerification = async () => {
        try {
            let url = "/verifications/id-verification";
            if (personalVerifications && personalVerifications.length > 0) {
                url = `/verifications/id-verification/${personalVerifications[0].verification_id}`;
            }
            const formData = new FormData();

            // Append video file (assumes recordedVideo is a File object)
            const videoBlob = await fetch(recordedVideo).then((res) => res.blob());
            formData.append("face_video", videoBlob, "faceVideo.mp4");

            const idFrontName = isPassport === "passport" ? "passport_front" : "license_front";
            const idBackName = isPassport === "passport" ? "passport_back" : "license_back";

            const frontBlob = base64ToBlob(idImages.frontSide, "image/jpeg");
            const backBlob = base64ToBlob(idImages.backSide, "image/jpeg");

            formData.append(idFrontName, frontBlob, "front.jpg");
            formData.append(idBackName, backBlob, "back.jpg");
            let response;
            if (personalVerifications && personalVerifications.length > 0) {
                response = await putApi(url, formData, true);
            } else {
                response = await postApi(url, formData, true);
            }
            if (response?.detail === 401) {
                navigate("/login");
                return;
            }

            const result = response.response;
            navigate("/verify/success");

            if (response.ok && !result.error) {
                // successToastMessage(result.message); // Call success notification
            } else {
                // errorToastMessage(result.error); // Call error notification
            }
        } catch (error) {
            console.error("Error submitting verification:", error);
            // Handle any additional error logic here
        }
    };

    return (
        <div className="tw-w-full tw-h-screen tw-pt-[70px]  tw-flex tw-overflow-y-auto tw-flex-col tw-items-center  ">
            <Header title={"Identity Verification"} />
            {count != 2 && <ProgressBar currentStep={3} totalSteps={3} />}
            {count == 1 && <FaceScanInstructions onStartRecording={() => setCount(2)} />}{" "}
            {count == 2 && <CameraHelp onStartRecording={() => setCount(3)} />}{" "}
            {count == 3 && <VideoRecorder onSubmitVerification={onSubmitVerification} setVideo={setRecordedVideo} />}
        </div>
    );
}
